import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const arrowButton = ({ expanded }: { expanded: boolean }) =>
  css({
    transform: `rotate(${expanded ? 0 : 180}deg)`,
  });

export const header =
  ({ expandable, expanded }: { expandable: boolean; expanded: boolean }) =>
  (theme: ExactTheme) =>
    css({
      display: "flex",
      padding: "17px 15px 15px 15px",
      cursor: expandable ? "pointer" : "default",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: expanded
        ? `1px solid ${theme.colorsV2.grey[100]}`
        : "unset",
    });

export const content = css`
  gap: 15px;
  display: flex;
  flex-direction: column;
  padding: 15px;
`;

export const body = css`
  padding: 15px;
`;
export const fields = css`
  gap: 15px;
  display: flex;
  flex-direction: column;
`;

export const arrow = css({
  transform: "rotate(180deg)",
});

export const root = css`
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
  border-radius: 6px;
`;

export const title = css`
  display: flex;
  gap: 10px;
  align-items: center;
`;
